export default "__VITE_ASSET__5ae90bbe__"